import Cookies from 'js-cookie'
import _ from 'lodash'

export function $tracker(pageLevelId, logType=10000, clickId='', params={}) {
  const popid = Cookies.get('siteLoginName') || ''
  const btype = Cookies.get('buzzType') || ''
  const tenantnum = Cookies.get('_platform_num') || ''
  const reportParams = _.omitBy({popid, btype, tenantnum, ...params}, _.isNil)
  try{
    if(logType === 10000){
      window.track && window.track._launch(
        {
          pageLevelId,
          logType,
          clickId,
          pageParam: JSON.stringify(reportParams)
        }
      )
    }else{
      window.track && window.track._launch(
        {
          pageLevelId,
          logType,
          clickId,
          positionParam: JSON.stringify(reportParams)
        }
      )
    }
  }catch(e){
    console.log(e)
  }
}
